const Instagram = ({
  color = "var(--primary500)",
  size = 24,
  onClick = () => {},
}) => {
  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5079_92026)">
        <rect width="120" height="120" rx="10" fill={color} />
        <g clipPath="url(#clip1_5079_92026)">
          <rect
            x="20.0005"
            y="15"
            width="80"
            height="90"
            rx="10"
            fill={color}
          />
          <path
            d="M60.0196 39.7866C48.6624 39.7866 39.5017 48.8042 39.5017 59.9839C39.5017 71.1635 48.6624 80.1811 60.0196 80.1811C71.3767 80.1811 80.5374 71.1635 80.5374 59.9839C80.5374 48.8042 71.3767 39.7866 60.0196 39.7866ZM60.0196 73.1147C52.6803 73.1147 46.6803 67.2261 46.6803 59.9839C46.6803 52.7417 52.6624 46.853 60.0196 46.853C67.3767 46.853 73.3588 52.7417 73.3588 59.9839C73.3588 67.2261 67.3588 73.1147 60.0196 73.1147V73.1147ZM86.1624 38.9604C86.1624 41.5796 84.0196 43.6714 81.3767 43.6714C78.716 43.6714 76.591 41.562 76.591 38.9604C76.591 36.3589 78.7338 34.2495 81.3767 34.2495C84.0196 34.2495 86.1624 36.3589 86.1624 38.9604ZM99.7517 43.7417C99.4481 37.4311 97.9838 31.8413 93.2874 27.2358C88.6088 22.6304 82.9303 21.189 76.5196 20.8726C69.9124 20.5034 50.1089 20.5034 43.5017 20.8726C37.1089 21.1714 31.4303 22.6128 26.7339 27.2183C22.0374 31.8237 20.591 37.4136 20.2696 43.7241C19.8946 50.228 19.8946 69.7221 20.2696 76.226C20.5732 82.5366 22.0374 88.1264 26.7339 92.7319C31.4303 97.3374 37.091 98.7788 43.5017 99.0952C50.1089 99.4643 69.9124 99.4643 76.5196 99.0952C82.9303 98.7963 88.6088 97.3549 93.2874 92.7319C97.966 88.1264 99.4303 82.5366 99.7517 76.226C100.127 69.7221 100.127 50.2456 99.7517 43.7417V43.7417ZM91.216 83.2046C89.8231 86.6499 87.1267 89.3042 83.6088 90.6928C78.341 92.7495 65.841 92.2749 60.0196 92.2749C54.1981 92.2749 41.6803 92.7319 36.4303 90.6928C32.9303 89.3217 30.2339 86.6674 28.8232 83.2046C26.7339 78.019 27.216 65.7143 27.216 59.9839C27.216 54.2534 26.7517 41.9311 28.8232 36.7632C30.216 33.3179 32.9124 30.6636 36.4303 29.2749C41.6981 27.2183 54.1981 27.6929 60.0196 27.6929C65.841 27.6929 78.3588 27.2358 83.6088 29.2749C87.1088 30.646 89.8053 33.3003 91.216 36.7632C93.3053 41.9487 92.8231 54.2534 92.8231 59.9839C92.8231 65.7143 93.3053 78.0366 91.216 83.2046Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5079_92026">
          <rect width="120" height="120" fill="white" />
        </clipPath>
        <clipPath id="clip1_5079_92026">
          <rect
            x="20.0005"
            y="15"
            width="80"
            height="90"
            rx="10"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Instagram;
